import { FC, ReactElement } from "react";
import { useDesktop } from "../../hooks/useDesktop";

type Props = {
  children: ReactElement;
};

export const Desktop: FC<Props> = ({ children }) =>
  useDesktop() ? children : null;
